export function formatDateForAPI(dateString: string): string {
  const formated = resetTimezone(new Date(dateString))
    .toISOString()
    .split("T")[0];
  return formated;
}
export function formatDateToUS(dateString: string): string {
  const ymd = formatDateForAPI(dateString).split('-');
  return `${ymd[1]}/${ymd[2]}/${ymd[0]}`;
}
export function resetTimezone(date: Date, multiplier = -1): Date {
  return new Date(date.getTime() + (date.getTimezoneOffset() * 60 * 1000 * multiplier));
}
export function getDateForDatepicker(dateString: string): Date {
  if (dateString.includes('/')) {
    const args = dateString.split('/').map(num => num.length == 1 ? '0' + num : num);
    dateString = `${args[2]}-${args[0]}-${args[1]}`;
  }
  return resetTimezone(new Date(dateString), 1);
}
